import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../helpers/api_helper';
import { CustomerBonusState, CustomerBonusType } from './types';
import { toast } from 'react-toastify';

export const getCustomerBonus = createAsyncThunk(
  'getCustomerBonus/fetch',
  async (id: number | null) => {
    const response = await axiosInstance.get(`/bonus/customer/${id}`);
    if (response.data.data.userOrder === null) {
      toast.error('Please type valid Order ID');
    }
    return response.data.data as CustomerBonusType;
  }
);

const initialState = {
  data: {},
  loading: false
} as CustomerBonusState;

const getCustomerBonusSlice = createSlice({
  name: 'getCustomerBonus',
  initialState,
  reducers: {
    // fill in primary logic here
  },
  extraReducers: (builder) => {
    builder.addCase(getCustomerBonus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCustomerBonus.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload;
    });
    builder.addCase(getCustomerBonus.rejected, (state) => {
      state.loading = false;
    });
  }
});

export default getCustomerBonusSlice.reducer;
